<template lang="pug">
a(style="cursor: pointer")
  .border.border-primary.text-primary.p-2.m-3 {{ title }}
</template>

<script>
export default {
  name: "Item",
  props: {
    title: String,
  },
};
</script>

<style lang="scss" scoped>
//
</style>
